import ShareableLinkDocumentMobileModal from './ShareableLinkDocumentMobileModal.component';

export default ShareableLinkDocumentMobileModal;
